import Typography from '@mui/material/Typography';
export default Typography;
export * from '@mui/material/Typography';
